import { z } from "zod";

/**
 * Makes every zod validation message an i18n key (under `validation.*`) instead of zod's built-in
 * English text, so forms can show it with t() in either language. Imported for its side effect by
 * each schema module.
 */
z.setErrorMap((issue, ctx) => {
	switch (issue.code) {
		case z.ZodIssueCode.invalid_type:
			return {
				message:
					issue.received === "undefined" || issue.received === "null"
						? "validation.required"
						: "validation.invalid",
			};
		case z.ZodIssueCode.too_small:
			if (issue.type === "array") return { message: "validation.itemsRequired" };
			if (issue.type === "string") return { message: "validation.required" };
			return { message: Number(issue.minimum) === 0 ? "validation.notNegative" : "validation.mustBePositive" };
		case z.ZodIssueCode.too_big:
			if (issue.type === "string") return { message: "validation.tooLong" };
			return { message: Number(issue.maximum) === 100 ? "validation.percentMax" : "validation.tooLarge" };
		case z.ZodIssueCode.invalid_enum_value:
			return { message: "validation.invalid" };
		default:
			return { message: ctx.defaultError === "Required" ? "validation.required" : "validation.invalid" };
	}
});

export {};
